export default __webpack_public_path__ + "static/media/default-card.dd914c86.png";